import React from 'react';
import styles from '../deialeticia1995/deialeticia1995.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import MakeIcon from '../../icons/makeIcon.tsx';
import catalogoPdf from './src/catalogo.pdf';
import MagazineIcon from '../../icons/magazineIcon.tsx';

const Deialeticia1995: React.FC = () => {
    return (
        <div className={styles.deialeticia1995}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Deia Letícia</h1>
                    <div className={styles["redes-sociais"]}>
                        <div >
                            <a href="https://www.instagram.com/deialeticia1995?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                                <InstagramIcon height="24" color="#cbb353" />
                            </a>
                            <a href="https://maps.app.goo.gl/BfUPvCH4QnWeWqy76" target="_blank">
                                <MapsIcon height="30" color="#cbb353" />
                            </a>
                        </div>
                    </div>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="https://wa.me/5517988106722?text=Olá, gostaria de agendar um horário..."
                                title="WHATSAPP"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517988106722?text=Olá, gostaria de mais informações sobre o curso de maquiagem..."
                                title="CURSO MAQUIAGEM"
                                icon={<MakeIcon height="40" width="40" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href={catalogoPdf}
                                title="CATÁLOGO"
                                icon={<CatalogIcon height="36" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                linkInterno={true}
                                href="/deialeticia1995/procedimentos"
                                title="PROCEDIMENTOS"
                                icon={<MagazineIcon height="36" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Deialeticia1995;
